import {
  useWSModalCustom,
  WSModal,
  WSText
} from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_TAX_WITHHOLDINGS } from "..";
import { PATH_TAX_WITHHOLDINGS } from "../../TaxWithholdings/paths";
import { OnboardingFlow } from "../components/OnboardingFlow";
import { OnboardingModule } from "../types";

const taxWithholdingsOnboardingModules: OnboardingModule[] = [
  {
    type: "tax_withholdings",
    hideIntro: true
  }
];

export const RouteTaxWithholdings: React.FC = () => {
  const history = useHistory();

  const modal = useWSModalCustom(props => (
    <WSModal
      title="Are you sure?"
      size="S"
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Secondary",
            label: "Yes",
            onClick: () => {
              history.push(PATH_TAX_WITHHOLDINGS);
              props.onClose?.(undefined);
            }
          },
          {
            kind: "Tertiary",
            label: "No",
            onClick: props.onClose
          }
        ]
      }}
      {...props}
    >
      <WSText.ParagraphSm color="gray600">
        Are you sure you want to exit tax withholdings setup?
      </WSText.ParagraphSm>
    </WSModal>
  ));

  return (
    <OnboardingFlow
      onBack={() => {
        modal.open();
      }}
      basePath={PATH_ONBOARDING_TAX_WITHHOLDINGS}
      modules={taxWithholdingsOnboardingModules}
      onSuccess={() => {
        history.push(PATH_TAX_WITHHOLDINGS);
      }}
    />
  );
};
